import type { MapperOptions } from '#layers/core/types'
import { mapperModuleMedia, mapperModuleNavigationLink, mapperModuleVideo } from '~/data-layer/modules/mappers'

export const mapperBlockCampaignsCardsItem = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  return {
    title: data.title || '',
    text: data.text || '',
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    image: mapperModuleMedia(data.image, options.imageOptions),
    video: mapperModuleVideo(data.video, options.imageOptions)
  }
}
